import { Component, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';

import { ProgressSpinner } from '@/app/shared/components/ui';

@Component({
  selector: 'app-dialog-loader',
  imports: [ProgressSpinner],
  templateUrl: './dialog-loader.html',
  styleUrl: './dialog-loader.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  host: {
    class: 'dialog-loader',
  },
})
export class DialogLoader {}
